// =============================================================================
// features/sales/campaigns/CampaignsStates.tsx — vazio (sem campanha / por
// filtro) e erro recuperável (F35-S07 DoD: "Estados: carregando, vazio real,
// vazio por filtro, erro..."). Loading é responsabilidade do ResponsiveTable
// (skeleton — nunca spinner sozinho, norma do DS). Mesmo padrão de
// features/sales/agenda/AgendaStates.tsx.
// =============================================================================

import * as React from 'react';

import { Button } from '../../../components/ui/Button';

export function CampaignsEmptyState({
  filtered,
  onClearFilters,
  onCreate,
  canCreate,
}: {
  filtered: boolean;
  onClearFilters: () => void;
  onCreate: () => void;
  canCreate: boolean;
}): React.JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-3 text-center px-4">
      <svg
        viewBox="0 0 48 48"
        fill="none"
        stroke="currentColor"
        strokeWidth={1}
        className="w-12 h-12 text-ink-4"
        aria-hidden="true"
      >
        <rect x="6" y="12" width="36" height="26" rx="3" />
        <path d="M6 20h36M14 8v8M34 8v8" strokeLinecap="round" />
        {!filtered && <path d="M16 29l5 5 11-11" strokeLinecap="round" strokeLinejoin="round" />}
      </svg>
      <div className="flex flex-col gap-1">
        <p
          className="font-display font-semibold text-ink"
          style={{ fontSize: 'var(--text-base)', letterSpacing: '-0.02em' }}
        >
          {filtered ? 'Nada encontrado com esses filtros' : 'Nenhuma campanha por aqui'}
        </p>
        <p className="font-sans text-sm text-ink-3 max-w-sm">
          {filtered
            ? 'Ajuste ou limpe os filtros para ver outras campanhas.'
            : 'Quando você criar uma campanha, ela aparece aqui — com indicadores, progresso e alertas.'}
        </p>
      </div>
      {filtered ? (
        <Button variant="outline" size="sm" onClick={onClearFilters}>
          Limpar filtros
        </Button>
      ) : (
        canCreate && (
          <Button variant="primary" size="sm" onClick={onCreate}>
            Nova campanha
          </Button>
        )
      )}
    </div>
  );
}

export function CampaignsErrorState({ onRetry }: { onRetry: () => void }): React.JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-4 text-center px-4">
      <svg
        viewBox="0 0 48 48"
        fill="none"
        stroke="currentColor"
        strokeWidth={1}
        className="w-12 h-12 text-danger"
        aria-hidden="true"
      >
        <circle cx="24" cy="24" r="18" />
        <path d="M24 16v10M24 30v2" strokeLinecap="round" />
      </svg>
      <div className="flex flex-col gap-1">
        <p
          className="font-display font-semibold text-ink"
          style={{ fontSize: 'var(--text-base)', letterSpacing: '-0.02em' }}
        >
          Não foi possível carregar as campanhas
        </p>
        <p className="font-sans text-sm text-ink-3 max-w-xs">
          Seus filtros foram mantidos. Verifique sua conexão e tente novamente.
        </p>
      </div>
      <Button variant="outline" size="sm" onClick={onRetry}>
        Tentar novamente
      </Button>
    </div>
  );
}
